export default [
  {
    path: '/',
    name: 'home',
    component: () => lazyLoadView(import('@views/pages/home.vue')),
  },
  {
    path: '/attraction/:slug',
    name: 'attraction',
    component: () => lazyLoadView(import('@views/pages/attraction-page.vue')),
    props: true,
  },
  {
    path: '/attractions',
    name: 'attractions',
    component: () => lazyLoadView(import('@views/pages/attractions.vue')),
  },
  {
    path: '/district/:slug',
    name: 'district',
    component: () => lazyLoadView(import('@views/pages/district.vue')),
    props: true,
  },
  {
    path: '/pass-and-card',
    name: 'passAndCard',
    component: () => lazyLoadView(import('@views/pages/pass-and-card.vue')),
  },
  {
    path: '/get-your-pass',
    name: 'getYourPass',
    component: () => lazyLoadView(import('@views/pages/get-your-pass.vue')),
  },
  {
    path: '/point/:slug',
    name: 'point',
    component: () =>
      lazyLoadView(import('@views/pages/points-of-sale-page.vue')),
    props: true,
  },
  {
    path: '/plan-your-trip',
    name: 'planYourTrip',
    component: () => lazyLoadView(import('@views/pages/plan-your-trip.vue')),
  },
  {
    path: '/news',
    name: 'news',
    component: () => lazyLoadView(import('@views/pages/current-news-page.vue')),
  },
  {
    path: '/article-page/:articleUrl',
    name: 'articlePage',
    component: () => lazyLoadView(import('@views/pages/article-page.vue')),
    props: true,
  },
  {
    path: '/faq',
    name: 'faq',
    component: () => lazyLoadView(import('@views/pages/faq-page.vue')),
  },
  {
    path: '/reviews',
    name: 'reviews',
    component: () => lazyLoadView(import('@views/pages/reviews.vue')),
  },
  {
    path: '/eshop',
    name: 'eshop',
    component: () => lazyLoadView(import('@views/pages/eshop.vue')),
    query() {
      return this.$route.query
    },
  },
  {
    path: '/contact-us',
    name: 'contactUs',
    component: () => lazyLoadView(import('@views/pages/contact-us-page.vue')),
  },
  {
    path: '/terms-and-conditions',
    name: 'termsAndConditions',
    component: () =>
      lazyLoadView(import('@views/pages/terms-and-conditions.vue')),
  },
  {
    path: '/about-us',
    name: 'aboutUs',
    component: () => lazyLoadView(import('@views/pages/about-us.vue')),
  },
  {
    path: '/cancellation-and-refund',
    name: 'cancellationAndRefund',
    component: () =>
      lazyLoadView(import('@views/pages/cancellation-and-refund.vue')),
  },
  {
    path: '/privacy-policy',
    name: 'privacyPolicy',
    component: () => lazyLoadView(import('@views/pages/privacy-policy.vue')),
  },
  {
    path: '/site-map',
    name: 'siteMap',
    component: () => lazyLoadView(import('@views/pages/site-map.vue')),
  },
  {
    path: '/areas',
    name: 'areas',
    component: () => lazyLoadView(import('@views/pages/areas.vue')),
  },
  {
    path: '/mobile-eshop',
    name: 'mobileEshop',
    component: () => lazyLoadView(import('@views/pages/mobile-eshop.vue')),
  },
]

function lazyLoadView(AsyncView) {
  const AsyncHandler = () => ({
    component: AsyncView,
    // loading: require('@views/_loading.vue').default,
    // delay: 500,
    error: require('@views/_timeout.vue').default,
    timeout: 30000,
  })

  return Promise.resolve({
    functional: true,
    render(h, { data, children }) {
      return h(AsyncHandler, data, children)
    },
  })
}
